/**
 * page-title.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {
  Box,
  Typography,
} from '@mui/material';
import Icon from 'components/icon';

const useStyles = makeStyles(theme => ({
  titleIcon: {
    fontSize: theme.typography.sizes[7],
    marginRight: theme.spacing(1),
    color: theme.palette.sys.onSurfaceVariant,
  },
}));

export default function PageTitle(props) {
  const {
    title,
    iconName,
    ...extraProps
  } = props;
  const classes = useStyles(props);

  return (
    <Box {...extraProps}>
      <Typography variant="h4" className='flex-hc'>
        <Icon type={iconName} className={classes.titleIcon} />
        {title}
      </Typography>
    </Box>
  );
}